import { render, staticRenderFns } from "./EventWeekTemplatePanel.vue?vue&type=template&id=fc1fa436&"
import script from "./EventWeekTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./EventWeekTemplatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports